var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.418 15.9347L17.5 18.018M16.6667 12.6014C16.6667 10.0701 14.6147 8.01807 12.0833 8.01807C9.552 8.01807 7.5 10.0701 7.5 12.6014C7.5 15.1327 9.552 17.1847 12.0833 17.1847C14.6147 17.1847 16.6667 15.1327 16.6667 12.6014Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 10.9347V14.268M13.7498 12.6014H10.4165",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 3.01807H11.6667M2.5 8.85137V12.1847M5.41667 18.018C3.80583 18.018 2.5 16.7122 2.5 15.1014M14.5833 3.01807C16.1942 3.01807 17.5 4.3239 17.5 5.93473M2.5 5.93473C2.5 4.3239 3.80583 3.01807 5.41667 3.01807",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInArea);
export default __webpack_public_path__ + "static/media/zoom-in-area.1eebb4ff1cea63726e38bc847619616a.svg";
export { ForwardRef as ReactComponent };